export const common = {
      language: 'Language',
      pagination: {
        previous: 'Previous',
        next: 'Next',
        pageOf: 'Page {{page}} of {{totalPages}}',
        itemsPerPage: 'Items per page',
      },
      loading: {
        title: 'Loading records',
        description: 'Fetching the latest information.',
        errorTitle: 'We could not load the information',
      },
      movementDirections: {
        in: 'Inbound',
        out: 'Outbound',
        adjustment: 'Adjustment',
        transfer: 'Transfer',
      },
      unitTypes: {
        piece: 'Piece',
        package: 'Package',
        weight: 'Weight',
        volume: 'Volume',
        length: 'Length',
        area: 'Area',
      },
      actions: {
        add: 'Add',
        select: 'Select',
        refresh: 'Refresh',
        edit: 'Edit',
        delete: 'Delete',
        save: 'Save',
        update: 'Update',
        close: 'Close',
        cancel: 'Cancel',
      },
      emptyStates: {
        noResultsTitle: 'No results',
        noResultsDescription: 'There are no records for the current filters.',
      },
      filters: {
        all: 'All',
      },
      validation: {
        required: 'This field is required.',
        email: 'Enter a valid email address.',
        duplicate: 'This value already exists.',
        duplicateCode: 'This code already exists.',
        duplicateEmail: 'This email already exists.',
        duplicateName: 'This name already exists.',
        duplicateSymbol: 'This symbol already exists.',
        duplicateCombination: 'This combination already exists.',
        distinctPackagingUnits: 'Presentation and contained unit must be different.',
        systemManagedDelete: 'System records cannot be deleted.',
        systemManagedUpdate: 'System records cannot be edited.',
        maxLength: 'Maximum {{count}} characters.',
        minLength: 'Minimum {{count}} characters.',
        invalidFormat: 'Invalid format.',
        minValue: 'Enter a value greater than or equal to {{count}}.',
        maxValue: 'Enter a value less than or equal to {{count}}.',
        requestFailed: 'Changes could not be saved.',
      },
      labels: {
        id: 'ID',
        code: 'Code',
        name: 'Name',
        contactName: 'Contact',
        customerType: 'Customer type',
        symbol: 'Symbol',
        description: 'Description',
        unitType: 'Type',
        allowsDecimals: 'Decimals',
        product: 'Product',
        client: 'Client',
        packageUnit: 'Packaging unit',
        presentationUnit: 'Presentation',
        referenceUnit: 'Contains',
        referenceQuantity: 'Quantity',
        baseUnit: 'Base unit',
        averageCost: 'Average cost',
        quantity: 'Quantity',
        pieces: 'Pieces',
        quantityInBaseUnit: 'Base unit quantity',
        inventoryValue: 'Inventory value',
        purchaseUnit: 'Used for purchase',
        saleUnit: 'Sold as',
        defaultPurchase: 'Preferred purchase',
        defaultSale: 'Preferred sale',
        costingUnit: 'Used for costing',
        direction: 'Direction',
        email: 'Email',
        phone: 'Phone',
        addressLine1: 'Address',
        city: 'City',
        state: 'State',
        country: 'Country',
        postalCode: 'Postal code',
        paymentTerms: 'Payment terms',
        taxId: 'Tax ID',
        market: 'Market',
        role: 'Role',
        status: 'Status',
        active: 'Status',
        lastAccess: 'Last access',
        actions: 'Actions',
        affectsInventory: 'Affects inventory',
        associatesWithClient: 'Associates with client',
        requiresReference: 'Requires reference',
        reference: 'Reference',
        system: 'System',
        date: 'Date',
        createdDate: 'Recorded on',
        createdBy: 'Created by',
        updatedDate: 'Updated on',
      },
      values: {
        yes: 'Yes',
        no: 'No',
        activeStatus: 'Active',
        inactiveStatus: 'Inactive',
        marketMx: 'Mexico',
        marketUs: 'USA',
        marketCa: 'Canada',
      },
    } as const;
